import { format } from "date-fns";
import { SiteCategoryType } from "./types";
import { COLORS, CONDITION_COLORS } from "./colors";

export const dateFormatter = (date: string) => {
  return date === "24:00" ? date : format(new Date(date), "HH:mm");
};

export const formatNumber = (ticks: any) => ticks.toLocaleString();

export const getLinkTotalPercent = (total: number, disconnected: number) => {
  const connectedQty = total - disconnected;
  return (connectedQty / total) * 100;
};

export const types = [
  {
    label: "EPLUS",
    value: "EPLUS",
  },
  {
    label: "PLANT",
    value: "PLANT",
  },
  {
    label: "LEAF",
    value: "LEAF",
  },
  {
    label: "EP",
    value: "EP",
  },
  {
    label: "WG",
    value: "WG",
  },
  {
    label: "SC",
    value: "SC",
  },
];

export const getSiteSelectList = (data: SiteCategoryType[]) => {
  const result = data.map((data) => ({
    label: data.name,
    value: data.siteNo,
  }));

  return result;
};

export const getZoneSelectList = (data: SiteCategoryType[], siteNo: string) => {
  if (siteNo !== "all") {
    const site = data.find((item) => item.siteNo === Number(siteNo));

    const result = site.zones.map((item) => ({
      label: item.name,
      value: item.zoneNo,
    }));

    return result;
  } else {
    return [];
  }
};

// 퍼센트 구하기
export const getExceptionNaNInfinityForRatio = (
  x: number,
  y: number,
  decimal: number
) => {
  if ((x / y) * 100 === Infinity) {
    return 100; // 무한이면 100 반환
  } else if (isNaN((x / y) * 100)) {
    return 0; // NaN이면 0 반환
  } else {
    return Math.round((x / y) * 100 * decimal) / decimal; // decimal로 소수점 표시
  }
};

export const getStatusInfo = (status: string) => {
  switch (status) {
    case "CONNECT":
      return {
        color: CONDITION_COLORS.normal,
        name: "connect",
      };
    case "DISCONNECT":
      return {
        color: COLORS.deepGray,
        name: "disconnect",
      };

    case "HIGH_TEMP":
      return { color: COLORS.lightOrange, name: "high-temp" };
    case "LOW_BATTERY":
      return { color: COLORS.purple, name: "low-battery" };
    case "FIRE":
      return { color: COLORS.darkRed2, name: "fire" };
  }
};

export const getPeakChartData = (data: any[]) => {
  const temp = [];

  for (let i in data) {
    temp.push({
      value: data[i].value,
      date: format(
        new Date(data[i].date).setMinutes(
          new Date(data[i].date).getMinutes() + 15
        ),
        "yyyy-MM-dd HH:mm"
      ),
    });
  } // for

  temp.push({ date: "24:00" });
  return temp;
};
